export type ViewMode = 'published' | 'preview';

export enum QuarterlyViewMode {
  QTR_COMPARABLE = 'QTR_COMPARABLE',
  QTR_ROLLING = 'QTR_ROLLING'
}

export const DEFAULT_QUARTERLY_VIEW_MODE = QuarterlyViewMode.QTR_ROLLING;

export const QUARTERLY_VIEW_MODE_OPTIONS = [
  { value: QuarterlyViewMode.QTR_ROLLING, label: 'Rolling' },
  { value: QuarterlyViewMode.QTR_COMPARABLE, label: 'Comparable' }
];

export const QUARTER_OPTIONS = [
  { value: 'QUARTER_1', label: 'Q1' },
  { value: 'QUARTER_2', label: 'Q2' },
  { value: 'QUARTER_3', label: 'Q3' },
  { value: 'QUARTER_4', label: 'Q4' }
];

/**
 * Number-of-years view mode for annual profile reports.
 * FIVE → 5 years (CY..PY3); TEN → 10 years (CY..PY8).
 * Sent to the enhanced-profiles-service as `yearsMode` query param.
 */
export enum YearsMode {
  FIVE = 'FIVE',
  TEN = 'TEN'
}

export const DEFAULT_YEARS_MODE = YearsMode.FIVE;

export const YEARS_MODE_OPTIONS = [
  { value: YearsMode.FIVE, label: '5-Year' },
  { value: YearsMode.TEN, label: '10-Year' }
];
